// Combines the event's date + time fields (stored separately) into the
// actual scheduled start moment - mirrors the same logic used server-side
// in attendanceController.js so the UI and the API agree on "has it started".
//
// Event times are always entered and understood as IST (this is an Indian
// institution's system) - so we anchor explicitly to IST (UTC+5:30) instead
// of the browser's local timezone. This keeps the frontend's "has it
// started" check consistent with the backend's enforcement no matter what
// timezone the visitor's device happens to be set to.
const IST_OFFSET_MINUTES = 5 * 60 + 30;

export const getEventStartDateTime = (event) => {
    const eventDate = new Date(event.date);
    const [hours, minutes] = (event.time || '00:00').split(':').map(Number);
    const utcMillis = Date.UTC(
        eventDate.getUTCFullYear(),
        eventDate.getUTCMonth(),
        eventDate.getUTCDate(),
        hours || 0,
        minutes || 0,
        0, 0
    ) - IST_OFFSET_MINUTES * 60 * 1000;
    return new Date(utcMillis);
};

export const hasEventStarted = (event) => new Date() >= getEventStartDateTime(event);

// Always display event times as IST, regardless of the viewer's own timezone
export const formatIST = (date) => date.toLocaleString('en-IN', {
    timeZone: 'Asia/Kolkata',
    dateStyle: 'medium',
    timeStyle: 'short'
});
